import { handleErrorResp, httpClient } from "../../../Service/Service";

export async function searchAgents() {
    try {
        return await httpClient<any>(`agent/getall/active`, "GET", {});
    } catch (err) {
        return handleErrorResp(err);
    }
}


export const fetchRefillTransactionsByAgent = async (agentName: string): Promise<any> => {
    try {
        return await httpClient<any>(`refillsale/get`, "POST", { agentName: agentName });
    } catch (err) {
        return handleErrorResp(err) as any;
    }
};

export async function addAgent(agentData: any) {
    try {
        return await httpClient<any>(`agent/add`, "POST", agentData);
    } catch (err) {
        return handleErrorResp(err);
    }
}
